<template>
  <div id="divParent" class="overlayConfirm"
    @click="$emit('cancelclick')"
    @keydown="exitConfirm"
    >
    <div class="myConfirm">
      <div class="myConfirm-content">
        <h5 style="width: 250px; margin: 16px;">{{text}}</h5>
        <button id="btnConfirm"
          @keydown="goToCancel"
          @click="$emit('confirmclick', paramReturn)">Confirmar</button>
        <button id="btnCancel"
          @keydown="goToConfirm"
          @click="$emit('cancelclick')">Cancelar</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    paramReturn: {
      type: Number,
      required: true,
      default: -1,
    },
  },
  watch: {
    paramReturn: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (!document.getElementById('divParent')) return true;
        if (newValue === -1) {
          document.getElementById('divParent').style.display = 'none';
        } else {
          document.getElementById('divParent').style.display = 'block';
          document.getElementById('btnConfirm').focus();
        }
      },
    },
  },
  methods: {
    focusCancelButton() {
      document.getElementById('btnCancel').focus();
    },
    goToCancel(event) {
      if (event.keyCode === 39) {
        document.getElementById('btnCancel').focus();
      }
    },
    goToConfirm(event) {
      if (event.keyCode === 37) {
        document.getElementById('btnConfirm').focus();
      }
    },
    exitConfirm(event) {
      if (event.keyCode === 9) {
        event.preventDefault();
      }
      if (event.keyCode === 27) {
        this.$emit('cancelclick');
      }
    },
  },
};
</script>

<style>
.overlayConfirm {
  height: 100%;
  width: 100%;
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  background-color: rgb(214, 211, 211, 0.2); /* Black fallback color */
  overflow-x: hidden; /* Disable horizontal scroll */
  transition: 0.5s;
  display: none;
}
div.myConfirm {
  border-radius: 16px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  box-shadow: 5px 5px 5px 5px rgb(124, 124, 124);
}
div.myConfirm-content {
  border: 30px;
  display: inline;
}
</style>
